import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CardChildren from '../../../../../commom/Cards/CardChildren'
import ForStudent from '../ForStudent/ForStudent'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { updatePermissionMenu } from '../../../../../../store/actions/menuActions'
import { Divider } from '@mui/material'

const Parent = ({ data = [], dashboardEnabled = false }) => {
  const permissions = useSelector((state) => state.session?.permissions || {})

  const licenses = useSelector((state) => state.tenant.license)
  const featureFlag = useSelector((state) => state?.tenant?.featureFlag || {})
  const user = useSelector((state) => state.session?.user || {})
  const { studentId } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const onClick = (studentId) => {
    dispatch(updatePermissionMenu(permissions, user, studentId, licenses, featureFlag))
    navigate(`/dashboard/${studentId}`)
  }

  if (data.length === 0) {
    return (
      <Box>
        <Typography variant='h5' color='textSecondary'>
          {"You don't have any student yet"}
        </Typography>
      </Box>
    )
  }
  return (
    <Box className=''>
      {/* <Typography variant='h5' color='primary'>
        Select a student
      </Typography> */}
      <div className='flex flex-wrap gap-4 my-4'>
        {data.map((item, i) => (
          <CardChildren
            key={`card-children-${item._id}-item-${i}`}
            id={`card-children-${item._id}`}
            title={item.name}
            photo={item.photo}
            data={{
              student: `${item.code} - ${item.fullName}`,
              yearLevel: item?.yearLevel?.map((year) => year?.name).join(', ')
            }}
            selected={item._id === studentId}
            className={item._id === studentId ? '' : 'filter-grayscale'}
            onClick={() => onClick(item._id)}
          />
        ))}
      </div>
      {studentId && dashboardEnabled && (
        <>
          <Divider />
          <ForStudent userId={studentId} />
        </>
      )}
    </Box>
  )
}

export default Parent
